import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const e=t("saint_vincent_and_the_grenadines",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5V20.5L0 20.5L0 4.5Z"
                fill="#FCD022" />
            <path
                d="M0 4.5L6 4.5L6 20.5H0L0 4.5Z"
                fill="#002674" />
            <path
                d="M18 4.5L24 4.5V20.5H18V4.5Z"
                fill="#007C2E" />
            <path
                d="M11.6089 11.1436L9.65017 8.88184L7.69141 11.1436L9.65017 13.4053L11.6089 11.1436Z"
                fill="#007C2E" />
            <path
                d="M16.31 11.1436L14.3512 8.88184L12.3924 11.1436L14.3512 13.4053L16.31 11.1436Z"
                fill="#007C2E" />
            <path
                d="M13.9594 13.858L12.0007 11.5962L10.0419 13.858L12.0007 16.1197L13.9594 13.858Z"
                fill="#007C2E" />
        </svg>
    `),d=t("saint_vincent_and_the_grenadines_rounded",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66519)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L24 0.5L24 24.5L0 24.5L0 0.5Z"
                    fill="#FCD022" />
                <path
                    d="M0 0.5L6 0.5L6 24.5H0L0 0.5Z"
                    fill="#002674" />
                <path
                    d="M18 0.5L24 0.5L24 24.5H18L18 0.5Z"
                    fill="#007C2E" />
                <path
                    d="M11.6089 12.4932L9.65017 9.10059L7.69141 12.4932L9.65017 15.8857L11.6089 12.4932Z"
                    fill="#007C2E" />
                <path
                    d="M16.31 12.4932L14.3512 9.10059L12.3924 12.4932L14.3512 15.8857L16.31 12.4932Z"
                    fill="#007C2E" />
                <path
                    d="M13.9594 16.5648L12.0007 13.1722L10.0419 16.5648L12.0007 19.9574L13.9594 16.5648Z"
                    fill="#007C2E" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66519">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{e as SaintVincentAndTheGrenadines,d as SaintVincentAndTheGrenadinesRounded};
